/* eslint-disable max-len */
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

export default function BranchSelect({selected,handleSelect,error}) {
    const location =useNavigate()
    const {branches}=useSelector(state=>state.auth);

    /**
     * The function `handleSelection` handles the selection of items based on a key and value, updating
     * the selected items accordingly.
     */
    const handleSelection = (key, val) => {
        if (key === 'all') {
            let arr = [];
            if (selected?.length !== branches?.length) {
                arr = branches;
            }
            handleSelect(arr);
        } else {
            const copy = [...selected];
            const idx = copy.map((item) => item.id).indexOf(val.id);
            if (idx !== -1) {
                copy.splice(idx, 1);
            } else {
                copy.push(val);
            }
            handleSelect(copy);
        }
    };
      
    return (
        <>{branches?.length>0 ?
            <div class={`border${error===true && selected?.length===0?' border-[#F04438]':' border-[#D0D5DDD0]'} rounded p-4 pr-[7px] error_border`} style={{'height':'173px'}}>
                <div class="h-[140px] overflow-y-auto scroll-smooth scroll-bar">
                    <div class="relative checkbox custom-checkBoxBlueBranch1 mb-2 flex">
                        <input type="checkbox" id="checkbox-a1"  checked={selected?.length===branches?.length} onChange={()=>handleSelection('all')}/>
                        <label for="checkbox-a1" class="text-f7 font-semibold text-[#031624] pl-2.5 w-full cursor-pointer">All Branches</label>
                    </div>
                    {branches.map((item,i)=>(
                        <div class="relative checkbox custom-checkBoxBlueBranch1 flex mb-1" key={item.id}>
                            <input type="checkbox" id={"checkbox-a1"+i} checked={selected.map(val=>val.id).indexOf(item.id) !==-1} onChange={()=>handleSelection('',item)}/>
                            <label for={"checkbox-a1"+i} class="text-f7 font-normal text-[#031624] pl-2.5 w-full cursor-pointer">{item.name}  {item?.status!=undefined && !item.status?" (Inactive)":"" }</label>
                        </div>
                    ))}
                </div> 
            </div> :<div className={`flex justify-center items-center border${error===true && selected?.length===0?'  border-[#F04438]':' border-[#D0D5DDD0]'} rounded p-4 pr-[7px] error_border`} style={{'height':'173px'}}>
                <div> No active branches available. <div> Click <a href="javascript:void(0)" class="text-[#106eb4]" onClick={() => location('/manage-branches/onboard-new-branch')}>
                    here
                </a> to add a branch</div>
                </div>
            </div>}
        </>
    )
}
